import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=46a52186&"
import script from "./CheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./CheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "veui-theme-dls/components/checkbox-group.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports